export default "__VITE_ASSET__CL$CfDYm__"